import moment from 'moment';

export function utcNow() {
  return moment.utc().toDate();
}
